// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__A7FAx","article":"Container_article__NcxJh","small":"Container_small__0k_5W","wide":"Container_wide__DEeFc"};